import { ReactNode } from 'react';
import { CurrencyField } from '../CurrencyField/CurrencyField';
import { DateField } from '../DateField/DateField';
import { TConditionalField } from '../refinancing.types';

import styles from './ConditionalField.module.css';

type TProps = {
  field: TConditionalField;
  fieldName: string;
  error?: string;
  disabled?: boolean;
};

export const ConditionalField = ({
  field,
  fieldName,
  error,
  disabled,
}: TProps) => {
  const { name, optional } = field;

  const label = (text: ReactNode): ReactNode =>
    optional ? (
      <>
        {text} <span className={styles.optional}>(optional)</span>
      </>
    ) : (
      text
    );

  switch (name) {
    case 'creditLimit':
      return (
        <CurrencyField
          name={`${fieldName}.creditLimit`}
          label={label('Credit limit')}
          error={error}
          disabled={disabled}
          shouldUnregister
        />
      );
    case 'monthlyRepayment':
      return (
        <CurrencyField
          name={`${fieldName}.monthlyRepayment`}
          label={label('Monthly repayment')}
          error={error}
          disabled={disabled}
          shouldUnregister
        />
      );
    case 'lastRepaymentDate':
      return <DateField fieldName={fieldName} label={label} error={error} />;
  }
};
